"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChatbotOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M4 4v21h10.68L23 30.94V25h5V4zm22 19h-5v4.06L15.32 23H6V6h20z" }),
        React.createElement("path", { d: "M16 21c2.75 0 5.19-1.51 5.94-3.67l-1.88-.66A4.18 4.18 0 0116 19a4.18 4.18 0 01-4.06-2.33l-1.88.66C10.81 19.49 13.25 21 16 21zM11 10h3v3h-3zM18 10h3v3h-3z" })));
}
exports.default = SvgChatbotOutline;
//# sourceMappingURL=ChatbotOutline.js.map